'use client'
import Radio from '@/app/components/controls/radio'
import SelectInput from '@/app/components/controls/select-input'
import { ModalContext } from '@/app/components/modal'
import { deactivateChannel } from '@/app/util/channel-api'
import { SubmitButton } from '@/components/button'
import Checkbox from '@/components/checkbox'
import { FlashMessageContext } from '@/context/flash-message'
import { cn } from '@/util/cn'
import { useContext, useEffect } from 'react'
import { useFormState } from 'react-dom'
import { ReasonsOptions } from './reasons'

const fieldNames = {
    note: 'note',
    reason: 'reason',
    reporter: 'reporter',
    sendEmail: 'send_email',
    userToDeactivate: 'userToDeactivate',
}

export const submitForm = async (
    _previousState: string | undefined | null,
    formData: FormData
): Promise<'success' | string> => {
    const params = {
        userToDeactivate: formData.get(fieldNames.userToDeactivate) as string,
        reason: formData.get(fieldNames.reason) as string,
        note: formData.get(fieldNames.note) as string,
        send_email: formData.get(fieldNames.sendEmail) === 'on',
        reporter: formData.get(fieldNames.reporter) as string,
    }
    try {
        await deactivateChannel(params)
        return 'success'
    } catch (_e) {}
    return 'Oops! Something went wrong. Please try again later.'
}
const DeactivateUser = () => {
    const { modal, setModalType } = useContext(ModalContext)
    const [result, formAction] = useFormState(submitForm, null)
    const { showMessage } = useContext(FlashMessageContext)
    useEffect(() => {
        let timeout: NodeJS.Timeout
        if (result) {
            if (result !== 'success') {
                showMessage({ message: result, type: 'success' })
            } else {
                // show modal for 3 seconds after success
                timeout = setTimeout(() => {
                    setModalType(null)
                }, 3000)
            }
        }
        return () => clearTimeout(timeout)
    }, [result, showMessage, setModalType])
    // this ensures types
    if (modal?.name !== 'deactivateUser') {
        return null
    }
    return result === 'success' ? (
        <div className="grid flex-1 place-items-center">
            <h1>Sent</h1>
        </div>
    ) : (
        <form
            className="group flex flex-1 flex-col gap-6 p-4 [&_h4]:font-normal [&_h4]:text-giphyLightGrey"
            action={formAction}
        >
            <input type="text" defaultValue={modal?.channel.user.username} name={fieldNames.userToDeactivate} hidden />
            <h1>
                Are you sure you want to deactivate{' '}
                <span className="text-giphyBlue">@{modal?.channel.user.username}</span>?
            </h1>
            <div className="flex flex-col gap-12">
                <SelectInput
                    required
                    name={fieldNames.reason}
                    placeholder="Select Reason"
                    className="w-full"
                    options={Object.entries(ReasonsOptions).map(([value, label]) => ({ label, value }))}
                />
                <section className="flex flex-col gap-2">
                    <h4>Reported By:</h4>
                    <div className="relative flex flex-1 gap-3">
                        <Radio
                            id={'proactive'}
                            label={'GIPHY Proactive'}
                            name={fieldNames.reporter}
                            required
                            value="GIPHY Proactive"
                        />
                        <Radio
                            id={'reported'}
                            label={'User Reported'}
                            name={fieldNames.reporter}
                            required
                            value="User Reported"
                        />
                    </div>
                </section>
                <section className="flex flex-col gap-2">
                    <h4>Any additional information?</h4>
                    <textarea
                        name={fieldNames.note}
                        placeholder="Enter additional details..."
                        className="m-0 w-full resize-none p-2.5 text-sm leading-[normal] font-normal text-black"
                    ></textarea>
                </section>
                <section className="flex cursor-pointer items-center gap-3">
                    <Checkbox id="sendemail" name={fieldNames.sendEmail} />{' '}
                    <label htmlFor="sendemail" className="cursor-pointer select-none">
                        Send Email to User
                    </label>
                </section>
            </div>
            <SubmitButton
                className={cn(
                    'w-full bg-gradient-error group-invalid:pointer-events-none group-invalid:bg-gradient-grey group-invalid:opacity-50'
                )}
            >
                Confirm Deactivation
            </SubmitButton>
        </form>
    )
}

export default DeactivateUser
